/**
 * @fileoverview gRPC-Web generated client stub for org.couchers.api.public_trips
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.26.1
// source: public_trips.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var annotations_pb = require('./annotations_pb.js')

var api_pb = require('./api_pb.js')
const proto = {};
proto.org = {};
proto.org.couchers = {};
proto.org.couchers.api = {};
proto.org.couchers.api.public_trips = require('./public_trips_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.org.couchers.api.public_trips.PublicTripsClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.org.couchers.api.public_trips.PublicTripsPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.org.couchers.api.public_trips.CreatePublicTripReq,
 *   !proto.org.couchers.api.public_trips.PublicTrip>}
 */
const methodDescriptor_PublicTrips_CreatePublicTrip = new grpc.web.MethodDescriptor(
  '/org.couchers.api.public_trips.PublicTrips/CreatePublicTrip',
  grpc.web.MethodType.UNARY,
  proto.org.couchers.api.public_trips.CreatePublicTripReq,
  proto.org.couchers.api.public_trips.PublicTrip,
  /**
   * @param {!proto.org.couchers.api.public_trips.CreatePublicTripReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.org.couchers.api.public_trips.PublicTrip.deserializeBinary
);


/**
 * @param {!proto.org.couchers.api.public_trips.CreatePublicTripReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.org.couchers.api.public_trips.PublicTrip)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.org.couchers.api.public_trips.PublicTrip>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.api.public_trips.PublicTripsClient.prototype.createPublicTrip =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.api.public_trips.PublicTrips/CreatePublicTrip',
      request,
      metadata || {},
      methodDescriptor_PublicTrips_CreatePublicTrip,
      callback);
};


/**
 * @param {!proto.org.couchers.api.public_trips.CreatePublicTripReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.org.couchers.api.public_trips.PublicTrip>}
 *     Promise that resolves to the response
 */
proto.org.couchers.api.public_trips.PublicTripsPromiseClient.prototype.createPublicTrip =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.api.public_trips.PublicTrips/CreatePublicTrip',
      request,
      metadata || {},
      methodDescriptor_PublicTrips_CreatePublicTrip);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.org.couchers.api.public_trips.GetPublicTripReq,
 *   !proto.org.couchers.api.public_trips.PublicTrip>}
 */
const methodDescriptor_PublicTrips_GetPublicTrip = new grpc.web.MethodDescriptor(
  '/org.couchers.api.public_trips.PublicTrips/GetPublicTrip',
  grpc.web.MethodType.UNARY,
  proto.org.couchers.api.public_trips.GetPublicTripReq,
  proto.org.couchers.api.public_trips.PublicTrip,
  /**
   * @param {!proto.org.couchers.api.public_trips.GetPublicTripReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.org.couchers.api.public_trips.PublicTrip.deserializeBinary
);


/**
 * @param {!proto.org.couchers.api.public_trips.GetPublicTripReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.org.couchers.api.public_trips.PublicTrip)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.org.couchers.api.public_trips.PublicTrip>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.api.public_trips.PublicTripsClient.prototype.getPublicTrip =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.api.public_trips.PublicTrips/GetPublicTrip',
      request,
      metadata || {},
      methodDescriptor_PublicTrips_GetPublicTrip,
      callback);
};


/**
 * @param {!proto.org.couchers.api.public_trips.GetPublicTripReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.org.couchers.api.public_trips.PublicTrip>}
 *     Promise that resolves to the response
 */
proto.org.couchers.api.public_trips.PublicTripsPromiseClient.prototype.getPublicTrip =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.api.public_trips.PublicTrips/GetPublicTrip',
      request,
      metadata || {},
      methodDescriptor_PublicTrips_GetPublicTrip);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.org.couchers.api.public_trips.ListPublicTripsReq,
 *   !proto.org.couchers.api.public_trips.ListPublicTripsRes>}
 */
const methodDescriptor_PublicTrips_ListPublicTrips = new grpc.web.MethodDescriptor(
  '/org.couchers.api.public_trips.PublicTrips/ListPublicTrips',
  grpc.web.MethodType.UNARY,
  proto.org.couchers.api.public_trips.ListPublicTripsReq,
  proto.org.couchers.api.public_trips.ListPublicTripsRes,
  /**
   * @param {!proto.org.couchers.api.public_trips.ListPublicTripsReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.org.couchers.api.public_trips.ListPublicTripsRes.deserializeBinary
);


/**
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.org.couchers.api.public_trips.ListPublicTripsRes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.org.couchers.api.public_trips.ListPublicTripsRes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.api.public_trips.PublicTripsClient.prototype.listPublicTrips =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.api.public_trips.PublicTrips/ListPublicTrips',
      request,
      metadata || {},
      methodDescriptor_PublicTrips_ListPublicTrips,
      callback);
};


/**
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.org.couchers.api.public_trips.ListPublicTripsRes>}
 *     Promise that resolves to the response
 */
proto.org.couchers.api.public_trips.PublicTripsPromiseClient.prototype.listPublicTrips =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.api.public_trips.PublicTrips/ListPublicTrips',
      request,
      metadata || {},
      methodDescriptor_PublicTrips_ListPublicTrips);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.org.couchers.api.public_trips.ListPublicTripsByUserReq,
 *   !proto.org.couchers.api.public_trips.ListPublicTripsByUserRes>}
 */
const methodDescriptor_PublicTrips_ListPublicTripsByUser = new grpc.web.MethodDescriptor(
  '/org.couchers.api.public_trips.PublicTrips/ListPublicTripsByUser',
  grpc.web.MethodType.UNARY,
  proto.org.couchers.api.public_trips.ListPublicTripsByUserReq,
  proto.org.couchers.api.public_trips.ListPublicTripsByUserRes,
  /**
   * @param {!proto.org.couchers.api.public_trips.ListPublicTripsByUserReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.org.couchers.api.public_trips.ListPublicTripsByUserRes.deserializeBinary
);


/**
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsByUserReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.org.couchers.api.public_trips.ListPublicTripsByUserRes)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.org.couchers.api.public_trips.ListPublicTripsByUserRes>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.api.public_trips.PublicTripsClient.prototype.listPublicTripsByUser =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.api.public_trips.PublicTrips/ListPublicTripsByUser',
      request,
      metadata || {},
      methodDescriptor_PublicTrips_ListPublicTripsByUser,
      callback);
};


/**
 * @param {!proto.org.couchers.api.public_trips.ListPublicTripsByUserReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.org.couchers.api.public_trips.ListPublicTripsByUserRes>}
 *     Promise that resolves to the response
 */
proto.org.couchers.api.public_trips.PublicTripsPromiseClient.prototype.listPublicTripsByUser =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.api.public_trips.PublicTrips/ListPublicTripsByUser',
      request,
      metadata || {},
      methodDescriptor_PublicTrips_ListPublicTripsByUser);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.org.couchers.api.public_trips.UpdatePublicTripReq,
 *   !proto.org.couchers.api.public_trips.PublicTrip>}
 */
const methodDescriptor_PublicTrips_UpdatePublicTrip = new grpc.web.MethodDescriptor(
  '/org.couchers.api.public_trips.PublicTrips/UpdatePublicTrip',
  grpc.web.MethodType.UNARY,
  proto.org.couchers.api.public_trips.UpdatePublicTripReq,
  proto.org.couchers.api.public_trips.PublicTrip,
  /**
   * @param {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.org.couchers.api.public_trips.PublicTrip.deserializeBinary
);


/**
 * @param {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.org.couchers.api.public_trips.PublicTrip)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.org.couchers.api.public_trips.PublicTrip>|undefined}
 *     The XHR Node Readable Stream
 */
proto.org.couchers.api.public_trips.PublicTripsClient.prototype.updatePublicTrip =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/org.couchers.api.public_trips.PublicTrips/UpdatePublicTrip',
      request,
      metadata || {},
      methodDescriptor_PublicTrips_UpdatePublicTrip,
      callback);
};


/**
 * @param {!proto.org.couchers.api.public_trips.UpdatePublicTripReq} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.org.couchers.api.public_trips.PublicTrip>}
 *     Promise that resolves to the response
 */
proto.org.couchers.api.public_trips.PublicTripsPromiseClient.prototype.updatePublicTrip =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/org.couchers.api.public_trips.PublicTrips/UpdatePublicTrip',
      request,
      metadata || {},
      methodDescriptor_PublicTrips_UpdatePublicTrip);
};


module.exports = proto.org.couchers.api.public_trips;

